import { InvoicePaymentListController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the report for the given invoice.
 * @example
 * ```html
 * <salaxy-invoice-payment-list payment-channel="$ctrl.paymentChannel"></salaxy-invoice-payment-list>
 * ```
 */
export class InvoicePaymentList extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {};

    /** Uses the InvoicePaymentListController */
    public controller = InvoicePaymentListController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/invoices/InvoicePaymentList.html";

}
